export default "__VITE_ASSET__OOfap3Sq__"